angular.module('unergie.main')
.filter('pdlType', () =>
    function (val) {
        switch (val) {
            case 'EP':
                return 'EP ou assimilés'
            case 'Batiment':
                return 'Bâtiment'
            default:
                return val
        }
    },
)
